import { ENERGY_USAGE } from './energy-usage';
import HOUSEHOLD_SIZES from './household-sizes';
import * as REGIONS from './regions';

const DEFAULTS = {
  region: REGIONS.NSW,
  renewableEnergy: {
    electricity: false,
    gas: false,
  },
  entryPage: 'plans',
  addressId: '',
  connectionAddressDPID: '',
  servicesRequired: {
    electricity: true,
    gas: true,
  },
  isBusiness: false,
  isResidential: true,
  iWantTo: '',
};

export default DEFAULTS;
